import { Currency } from '../models/enums/currency';

export class CurrencyUtil {

    private static readonly twoDecimals = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
    });

    static formatCurrency(value: number, currency: Currency = Currency.BRL, maxFractionDigits: number = 2): string {
        if (value === null || value === undefined) {
            return '';
        }

        const safeCurrency = currency || Currency.BRL;

        const locale = this.getCurrencyLocale(safeCurrency);
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: safeCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: maxFractionDigits
        });

        return formatter.format(value);
    }

    // Valor arredondado a 2 casas pela mesma regra do Intl que a tela usa para exibir
    // (Math.round(x * 100) / 100 erra o meio centavo: 500,70 - 25,035 viraria 475,67 e a tela
    // mostra 475,66). Nulo, vazio, NaN ou infinito = 0.
    static toCurrencyNumber(value: number | string | null | undefined): number {
        const num = value == null || value === '' ? 0 : Number(value);
        return isFinite(num) ? Number(this.twoDecimals.format(num)) : 0;
    }

    private static getCurrencyLocale(currency: Currency): string {
        
        const safeCurrency = currency || Currency.BRL;
        
        switch (safeCurrency) {
            case Currency.BRL:
                return 'pt-BR';
            case Currency.USD:
                return 'en-US';
            case Currency.EUR:
                return 'de-DE';
            default:
                return 'pt-BR';
        }
    }

    static getCurrencySymbol(currency: Currency): string {
        
        const safeCurrency = currency || Currency.BRL;
        
        switch (safeCurrency) {
            case Currency.BRL:
                return 'R$';
            case Currency.USD:
                return '$';
            case Currency.EUR:
                return '€';
            default:
                return 'R$';
        }
    }

} 